import { notification } from 'antd';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { uploadSecondaryMarketTransactionsExcel } from './secondaryMarketApis';

export const useUploadSecondaryMarketTransactionsExcel = (closeModal: () => void) => {
    return useMutation('useUploadSecondaryMarketTransactionsExcel', uploadSecondaryMarketTransactionsExcel, {
        onSuccess: (data) => {
            const description = data.data.data.msg || 'Successfully uploaded excel file.';
            closeModal();
            notification.success({ message: 'Upload Secondary Market Transactions Excel', description });
        },
        onError: (error: AxiosError<CapBayApiError>) => {
            const errorMsg = error.response?.data.error.message;
            if (errorMsg) {
                notification.error({ message: 'Upload Secondary Market Transactions Excel', description: errorMsg });
            } else {
                notification.error({ message: 'Upload Secondary Market Transactions Excel', description: 'Something went wrong. Please try again later.' });
            }
        },
    });
};
